"use strict";

var _class, _RectangleParameterEditor;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from "react";
import PropTypes from "prop-types";
import defined from "terriajs-cesium/Source/Core/defined";
import Styles from "./parameter-editors.scss";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import Ellipsoid from "terriajs-cesium/Source/Core/Ellipsoid";
import UserDrawing from "../../Models/UserDrawing";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { runInAction } from "mobx";
import CommonStrata from "../../Models/Definition/CommonStrata";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let RectangleParameterEditor = observer(_class = (_RectangleParameterEditor = class RectangleParameterEditor extends Component {
  setValueFromText(e) {
    RectangleParameterEditor.setValueFromText(e, this.props.parameter);
  }
  selectPolygonOnMap() {
    selectOnMap(this.props.previewed.terria, this.props.viewState, this.props.parameter);
  }
  render() {
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("input", {
        className: Styles.field,
        type: "text",
        onChange: this.setValueFromText.bind(this),
        value: getDisplayValue(this.props.parameter.value)
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: this.selectPolygonOnMap.bind(this),
        className: Styles.btnSelector,
        children: t("analytics.clickToDrawRectangle")
      })]
    });
  }
}, _defineProperty(_RectangleParameterEditor, "propTypes", {
  previewed: PropTypes.object,
  parameter: PropTypes.object,
  viewState: PropTypes.object,
  t: PropTypes.func.isRequired
}), _RectangleParameterEditor)) || _class;
/**
 * Triggered when user types value directly into field.
 * @param {String} e Text that user has entered manually.
 * @param {FunctionParameter} parameter Parameter to set value on.
 */
RectangleParameterEditor.setValueFromText = function (e, parameter) {
  parameter.setValue(CommonStrata.user, [JSON.parse(e.target.value)]);
};

/**
 * Given a value, return it in human readable form for display.
 * @param {Object} value Native format of parameter value.
 * @return {String} String for display
 */
export function getDisplayValue(value) {
  if (!defined(value)) {
    return "";
  }
  return "".concat(value.east, ", ").concat(value.north, ", ").concat(value.west, ", ").concat(value.south);
}

/**
 * Prompt user to select/draw on map in order to define parameter.
 * @param {Terria} terria Terria instance.
 * @param {Object} viewState ViewState.
 * @param {FunctionParameter} parameter Parameter.
 */
export function selectOnMap(terria, viewState, parameter) {
  const userDrawing = new UserDrawing({
    terria: terria,
    drawRectangle: true,
    onCleanUp: function () {
      viewState.openAddData();
    },
    onDrawingComplete: function (params) {
      if (params.points) {
        const cartographicPoints = params.points.map(point => {
          const cartographic = Cartographic.fromCartesian(point, Ellipsoid.WGS84);
          return {
            latitude: CesiumMath.toDegrees(cartographic.latitude),
            longitude: CesiumMath.toDegrees(cartographic.longitude)
          };
        });
        const rectangle = {
          west: cartographicPoints[0].longitude,
          south: cartographicPoints[0].latitude,
          east: cartographicPoints[1].longitude,
          north: cartographicPoints[1].latitude
        };
        runInAction(() => {
          parameter.setValue(CommonStrata.user, rectangle);
        });
      }
    }
  });
  userDrawing.enterDrawMode();
}
export default withTranslation()(RectangleParameterEditor);